@if (!isCustomCut()) {
  <ideal-wire-cut-item-description
    class="fancy"
    [itemId]="id()"
    *renderInItemResult="LayoutTargets.ImportantInfo; id: 'description'; priority: -1"
  ></ideal-wire-cut-item-description>
  <ideal-item-stock-button [itemId]="id()" *renderInItemResult="LayoutTargets.Stock; id: 'stock-btn'; priority: -1" />
} @else {
  <span custom-cut-label *renderInItemResult="LayoutTargets.Title; id: 'custom-cut-label'; priority: -1">Custom Cut Lengths</span>
  <ideal-product-not-returnable-view
    not-returnable
    line
    [returnable]="false"
    *renderInItemResult="LayoutTargets.ImportantInfo; id: 'not-returnable'; priority: -1"
  ></ideal-product-not-returnable-view>
  <span custom-cut-notice *renderInItemResult="LayoutTargets.ImportantInfo; id: 'custom-cut-notice'; priority: -1"
    >* Subject to additional reel charge</span
  >
}

<ideal-item-price
  [itemId]="id()"
  xsizing="fixed"
  disableUnits="true"
  disableCallForPrice="false"
  usePricePer="sold-in"
  layout="horizontal"
  *renderInItemResult="LayoutTargets.Price; id: 'price'; priority: -1"
></ideal-item-price>
